import * as React from 'react'
import { Input } from '@/components/ui/input'

export interface NumberInputProps
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'value' | 'onChange' | 'type'> {
  value: number | undefined | null
  onChange: (value: number | undefined) => void
}

/**
 * 千分位数字输入: 显示时按会计标准分组(1,200,000), 存储/回调为纯数字。
 * 全站需要"目标字数"等大数字输入的地方统一使用, 避免裸 1200000 难识别。
 */
function formatGrouped(value: number | undefined | null): string {
  if (value === undefined || value === null || Number.isNaN(value)) return ''
  return value.toLocaleString('en-US')
}

export const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, onChange, inputMode = 'numeric', ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="text"
        inputMode={inputMode}
        value={formatGrouped(value)}
        onChange={(event) => {
          const digits = event.target.value.replace(/[^\d]/g, '')
          onChange(digits ? Number(digits) : undefined)
        }}
        {...props}
      />
    )
  },
)
NumberInput.displayName = 'NumberInput'
